"use strict";
/**
 * @see https://bytedance.sg.larkoffice.com/docx/HWFKdIr5honItyxDOUglWd8rgWX
 * @see https://bytedance.larkoffice.com/wiki/wikcnbcycVBhgOkzajrdNtX5x3d
 * @see https://bytedance.larkoffice.com/wiki/Y3Q7wnwwGi0d9NkBWEOcZAs4nNf
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildInnerHtml = exports.filterXSS = void 0;
// @ts-ignore
const blackForModule_umd_1 = require("@ies/filter-xss/dist/blackForModule.umd");
const filterXSS = (html) => (0, blackForModule_umd_1._filterXSS)(html, null, { mode: 'black', block: true });
exports.filterXSS = filterXSS;
const buildInnerHtml = (html) => {
    return {
        __html: (0, exports.filterXSS)(html),
    };
};
exports.buildInnerHtml = buildInnerHtml;
